<template>
    <div id="page-customer" class="vx-card p-6">
        <!-- Searchs-->
        <vx-card ref="filterCard" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
            <div class="vx-row">
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">ID</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="ID" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.id"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">メールアドレス</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="メールアドレス（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.email"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">名前</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="名前（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.name"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">電話</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="電話（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.phone_number"/>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">お客様種別</label>
                    <!-- <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="お客様種別（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.customer_type"/> -->
                    <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                              label="value" :searchable="false" :reduce="item => item.key" :options="customerTypeFilter" v-model="filterCustomers.customer_type">
                    </v-select>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">会社名</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="会社名（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.company_name"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">業種名</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="業種名（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.industry_name"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-75">住所</label>
                    <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="住所（部分一致）" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterCustomers.address"/>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt">
                    <vs-button icon="search" @click="pageNumber = 1; searchWithOrder(); ids = []" class="search_icon mr-6 sm:mr-3">検索 </vs-button>
                </div>
            </div>
        </vx-card>

        <!-- Title and Buttons Action -->
        <div class="text-title">
            <span>顧客一覧</span>
        </div>
        <vs-row class="pl-2">
            <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
                <span class="pr-2">表示件数:</span>
                <div class="vx-col md:w-1/5 w-full">
                    <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
                        <span slot="no-options" class="text-xs">マッチングオプションがありません。</span>
                    </v-select>
                </div>
            </vs-col>
            <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">
                <vue-json-to-csv ref="exportCSV" style="display: none" csv-title="Customer_CSV" :labels="labelExport" :json-data="dataExport"></vue-json-to-csv>
                <vs-button icon="settings" class="mt-1" @click="openFieldSetting" color="#3287bf">項目追加</vs-button>
                <vs-button color="#1976d2" icon="file_download" class="mt-1" @click="onExportCSV">ＣＳＶ出力</vs-button>
                <vs-button :disabled="ids.length > 0 ? false:true" class="mt-1" color="danger" icon="delete" @click="activeDelete = true">削除</vs-button>
                <vs-button color="#1976d2" icon="file_upload" class="mt-1" @click="activeUpload = true">ＣＳＶ取り込み</vs-button>
                <vs-button color="success" icon="person_add" class="mt-1" @click="setUpCreate">登録</vs-button>
            </vs-col>
        </vs-row>

        <vs-popup id="dialogImport" title="CSV取り込み" :active.sync="activeUpload" button-close-hidden>
            <span>
                CSVファイルで顧客データをインポートします。
            </span>
            <div class="flex justify-center mt-4" v-if="fileUploadCheck">
                <vs-button disabled icon="check" size="large" class="mb-5 mt-5">{{fileName}}</vs-button>
            </div>
            <div class="flex justify-center mt-4">
                <input id="fileUpload" type="file" accept=".csv" ref="fileUpload" @change="importFileChange" hidden />
                <vs-button @click="$refs.fileUpload.click()" icon="file_upload" size="large" type="line" class="mb-5 mt-5">{{ !fileUploadCheck ? "ファイル選択" : "ファイル選択"}}</vs-button>
            </div>
            <div v-if="fileImportError.flag" class="flex justify-center mt-1 mb-5">
                <span class="text-danger">{{fileImportError.message}}</span>
            </div>
            <div class="flex justify-center mt-4">
                <vs-button @click="importCSV" icon="check" color="success" :disabled="!validFile" class="mx-2">取り込み</vs-button>
                <vs-button @click="resetFileImport" icon="cancel" color="lightgrey">キャンセル</vs-button>
            </div>
        </vs-popup>
        <vs-popup id="dialogImportError" title="CSV取込みを失敗しました。" :active.sync="activeError" button-close-hidden>
            <div class="error-statistical">
                <div v-if="datImportError && datImportError.details">

                    <div v-if="dataLimited == false">
                        <div v-for="(item, key) in datImportError.details" class="item-error">
                            <h4 class="mb-2">
                                行目 {{datImportError.line[key]}} :  {{convertErrorImport(datImportError.details[key])}}
                            </h4>
                        </div>
                    </div>
                    <div >
                    </div>
                </div>
                <div v-if="dataLimited">
                    <div v-if="messageErrorMax =='max'" class="item-error">
                        <h4 class="mb-2 text-center">
                            CSV取り込みは100レコード以下をインポートしてください
                        </h4>
                    </div>
                    <div class="item-error" v-if="messageErrorMin =='min'">
                        <h4 class="mb-2 text-center">
                            ファイル形式が正しくありません。
                        </h4>
                    </div>
                    <div class="item-error" v-if="messageNotHasHeader == true">
                        <h4 class="mb-2 text-center">
                            ファイル形式が正しくありません。
                        </h4>
                    </div>
                    <div class="item-error" v-if="messageIncorectFormat == true">
                        <h4 class="mb-2 text-center">
                            CSVファイル形式が正しくありません。
                        </h4>
                    </div>
                </div>
                <div v-if="importHasOtherError && !dataLimited && !(datImportError && datImportError.details)">
                    <div class="item-error">
                        <h4 class="mb-2 text-center">
                            {{ convertErrorImport(importHasOtherError) }}
                        </h4>
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <vs-button @click="activeError = false" icon="cancel" color="lightgrey">閉じる</vs-button>
            </div>
        </vs-popup>

        <vs-popup id="dialogDelete" title="顧客の削除" :active.sync="activeDelete" button-close-hidden>
            <div>
          <span>
            選択した顧客を削除しますか？
          </span>
            </div>
            <div class="flex justify-end mt-4">
                <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
                <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
            </div>
        </vs-popup>
      <vs-popup :title="`項目追加`" :active="addFieldPopup" button-close-hidden>
        <vx-card title="項目追加"
                 card-background ="rgb(240, 238, 241)"
                 height="420px"
                 class="pb-2"
                 style="font-size: 12px">
          <vs-row>
            <vs-col vs-w="12">
              <vs-row>
                <vs-col class="flex items-center" vs-w="3">
                  <span>項目名<span style="color: red">*</span></span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-input maxlength="64" v-model="fieldAdd.field_name" class="w-full mb-2" placeholder="項目名"/>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-w="3"></vs-col>
                <vs-col vs-w="9">
                  <span v-show="addFieldValidate" class="mb-2 text-danger font-size-info" style="display: block;">項目名は必須です。</span>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col class="flex items-center" vs-w="3">
                  <span>データ型</span>
                </vs-col>
                <vs-col vs-w="7">
                  <vs-row>
                    <div class="mr-4 my-3 d-flex">
                        <input id="field_type1" type="radio" v-model="fieldAdd.field_type" :value="1" name="field_type" class="mr-1" style="position: relative; top: 2px"/>
                        <label for="field_type1" class="mr-6">数値</label>
                        <input id="field_type2" type="radio" v-model="fieldAdd.field_type" :value="2" name="field_type" class="mr-1" style="position: relative; top: 2px"/>
                        <label for="field_type2" class="mr-6">日付</label>
                        <input id="field_type3" type="radio" v-model="fieldAdd.field_type" :value="3" name="field_type" class="mr-1" style="position: relative; top: 2px"/>
                        <label for="field_type3" class="mr-6">テキスト</label>
                    </div>
                  </vs-row>
                </vs-col>
                <vs-col vs-w="2">
                  <vs-button @click="addField" class="ml-6" :disabled="addFieldValidate" icon="add" color="success" style="padding: 8px; height: 37px;min-width: 63px;">登録</vs-button>
                </vs-col>
              </vs-row>

            </vs-col>
          </vs-row>
          <vs-col class="my-5"><b>項目追加</b></vs-col>
          <CustomerFieldsByCompany :key="customerFieldsRerender" :company-action="companyAction"
                                   @fetchFieldsList="fetchCustomerFields"
                                   :customer-fields-by-company="customerFieldsByCompany"/>
        </vx-card>
        <div style="display: flex; justify-content: flex-end" class="pt-4">
          <vs-button @click="cancelAddField" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px;min-width: 77px;">閉じる</vs-button>
        </div>
      </vs-popup>

        <!-- Create and Edit Dialog -->
        <vs-popup id="dialogUpdate" :title="dialogTitle" :active.sync="activePopup" button-close-hidden>
            <vx-card title="顧客詳細"
                     card-background ="rgb(240, 238, 241)"
                     height="420px"
                     class="pb-2"
                     style="font-size: 12px">

                <vs-row>
                    <vs-col vs-w="6">
                        <vs-col class="flex items-center" vs-w="3"><span style="width: 100%; height: 1px"></span></vs-col>
                        <vs-col class="flex items-center" vs-w="3"><span class="show-error">{{errorUpdateOrCreate}}</span></vs-col>
                    </vs-col>
                    <vs-col vs-w="6"></vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-w="6">
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span class="pt-2">ID</span>
                            </vs-col>
                            <vs-col vs-w="3">
                                <vs-input disabled class="w-full mb-2" :value="customer.id"/>
                            </vs-col>
                        </vs-row>
                         <!-- customer type -->
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>お客様種別</span>
                            </vs-col>
                            <vs-col vs-w="9">
                                <vs-row>
                                    <div class="mr-4 my-3" v-for="type in customerType" :key="type.key">
                                        <input type="radio" v-model="customer.customer_type_flg" :value="type.key" name="customer_type" class="mr-1" style="position: relative; top: 2px"/>
                                        <span>{{ type.value }}</span>
                                    </div>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                        <!-- next -->
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>名前<span style="color: red">*</span></span>
                            </vs-col>
                            <vs-col vs-w="4">
                                <vs-input v-validate.immediate="'required'" maxlength="64" data-vv-as="姓" name="last_name" v-model="customer.last_name" class="w-full mb-2" placeholder="姓(漢字)"/>
                            </vs-col>
                            <vs-col vs-w="1"></vs-col>
                            <vs-col vs-w="4">
                                <vs-input v-validate.immediate="'required'" maxlength="64"  data-vv-as="名" name="first_name" v-model="customer.first_name" class="w-full mb-2" placeholder="名(漢字)"/>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col vs-offset="3" vs-w="4">
                                <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("last_name") | convertError }}</span>
                            </vs-col>
                            <vs-col vs-w="1"></vs-col>
                            <vs-col vs-w="4">
                                <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("first_name") | convertError }}</span>
                            </vs-col>
                        </vs-row>
                        <!-- next -->

                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>よみがな</span>
                            </vs-col>
                            <vs-col vs-w="4">
                                <vs-input maxlength="64" v-model="customer.last_name_kana" class="w-full mb-2" placeholder="姓(ひらがな)"/>
                            </vs-col>
                            <vs-col vs-w="1"></vs-col>
                            <vs-col vs-w="4">
                                <vs-input maxlength="64" v-model="customer.first_name_kana" class="w-full mb-2" placeholder="名(ひらがな)"/>
                            </vs-col>
                        </vs-row>

                        <!-- next -->
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>性別</span>
                            </vs-col>
                            <vs-col vs-w="9">
                                <vs-row>
                                    <div class="mr-4 my-3" v-for="type in genderType" :key="`gender-key-${type.key}`">
                                        <input type="radio" v-model="customer.gender" :value="type.key"  name="gender_type" class="mr-1" style="position: relative; top: 2px"/>
                                        <span>{{ type.value }}</span>
                                    </div>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                        <!-- next -->
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>メールアドレス<span style="color: red">*</span></span>
                            </vs-col>
                            <vs-col vs-w="4">
                                <vs-input v-model="customer.email1" v-validate.immediate="'required|email|override-email'" data-vv-as="メールアドレス" maxlength="256" name="email1" placeholder="メールアドレスを入力" class="w-full mb-2"/>
                            </vs-col>
                            <vs-col vs-w="1"></vs-col>
                            <vs-col vs-w="4">
                                <vs-input v-model="customer.email2" v-validate.immediate="'email|override-email'" data-vv-as="メールアドレス" name="email2" maxlength="256" placeholder="メールアドレスを入力" class="w-full mb-2"/>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                          <vs-col vs-offset="3">
                            <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("email1") | convertError }}</span>
                            <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("email2") | convertError }}</span>
                          </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>電話番号</span>
                            </vs-col>
                            <vs-col vs-w="4">
                                <vs-row>
                                    <vs-input v-validate.immediate="'numeric'" name="電話番号" v-model="customer.phone_number1" maxlength="15" placeholder="(半角･ハイフンなし)" class="w-full mb-2"/>
                                </vs-row>
                            </vs-col>
                            <vs-col vs-w="1"></vs-col>
                            <vs-col vs-w="4">
                                <vs-row>
                                    <vs-input v-validate.immediate="'numeric'" name="電話番号" v-model="customer.phone_number2" maxlength="15" placeholder="(半角･ハイフンなし)" class="w-full mb-2"/>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                          <vs-col vs-offset="3">
                            <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("電話番号") | convertError }}</span>
                          </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col class="flex items-center" vs-w="3">
                                <span>FAX</span>
                            </vs-col>
                            <vs-col vs-w="9">
                                <vs-row>
                                    <vs-input v-validate.immediate="'numeric'" name="FAX" v-model="customer.fax_number" maxlength="15" placeholder="例：0312345678 (半角･ハイフンなし)" class="w-full mb-2"/>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                      <vs-row>
                        <vs-col vs-offset="3">
                          <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("FAX") | convertError }}</span>
                        </vs-col>
                      </vs-row>

                      <vs-row>
                        <vs-col class="flex items-center" vs-w="3">
                          <span>メールドメイン</span>
                        </vs-col>
                        <vs-col vs-w="9">
                          <vs-row>
                            <vs-input name="メールドメイン" v-validate.immediate="'mail-domain'" v-model="customer.mail_domain" maxlength="64" placeholder="メールドメイン" class="w-full mb-2"/>
                          </vs-row>
                        </vs-col>
                      </vs-row>
                      <vs-row>
                        <vs-col vs-offset="3">
                          <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("メールドメイン") | convertError }}</span>
                        </vs-col>
                      </vs-row>

                        <vs-row>
                          <vs-col class="flex items-center" vs-w="3">
                                <span>サブスクライブ</span>
                            </vs-col>
                            <vs-col vs-w="9" class="flex flex-wrap ml-0 mt-4">
                                 <vs-checkbox class="mb-4 w-2/5 mr-8" v-for="(subscription, index) in subscriptionsForCustomer" v-model="subscription.isCheck" :key="`subscription-${index}`">{{ subscription.name }}</vs-checkbox>
                            </vs-col>
                        </vs-row>

                      <CustomerFieldsByCompany :key="customerFieldsRerender" :company-action="companyAction"
                                               @fetchFieldsList="fetchCustomerFields"
                                               :customer-fields-by-company="customerFieldsByCompany"/>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="ml-16">
                            <!-- right -->
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>会社名</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-model="customer.company_name" name="会社名" maxlength="128" class="w-full mb-2" placeholder="株式会社〇〇"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                              <vs-col vs-offset="3">
                                <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("会社名") | convertError }}</span>
                              </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>よみがな</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-model="customer.company_name_kana" maxlength="64" class="w-full mb-2" placeholder="かぶしきかいしゃ〇〇"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>業種名</span>
                                </vs-col>
                                <vs-col vs-w="3">
                                    <vs-input v-model="customer.industry_name" maxlength="256" name="業種名" class="w-full mb-2 mr-2" placeholder="業種名を入力" /></vs-col>
                                <vs-col class="flex items-center text-center" vs-w="3">
                                    <span class="w-full text-center">部署名</span>
                                </vs-col>
                                <vs-col vs-w="3">
                                    <vs-row>
                                        <vs-input v-model="customer.department_name" maxlength="64" class="w-full mb-2" placeholder="部署名を入力"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                              <vs-col vs-offset="3">
                                <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("業種名") | convertError }}</span>
                              </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>郵便番号</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-model="customer.postal_code" name="郵便番号" maxlength="64" class="w-full mb-2" placeholder="例：0001234 (半角･ハイフンなし)"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                              <vs-col vs-offset="3">
                                <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("郵便番号") | convertError }}</span>
                              </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>都道府県</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                  <v-select class="sl-prefecture w-full mb-2 bg-white"  placeholder="選択してください"
                                            label="value" :searchable="false" :reduce="item => item.value" :options="prefectureOptions" v-model="customer.prefecture_name">
                                  </v-select>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>住所</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-model="customer.address" maxlength="256" class="w-full mb-2" placeholder="例：〇〇市△△区〇〇町0-0"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>購入先</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-model="customer.retailer_name" maxlength="64" class="w-full mb-2" placeholder="購入先を入力"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" style="align-self: baseline" vs-w="3">
                                    <span>備考</span>
                                </vs-col>
                                <vs-col vs-w="9" class="remark-textarea">
                                    <vs-textarea v-model="customer.remarks" maxlength="256" class="w-full mb-2" placeholder="備考を入力"/>
                                </vs-col>
                            </vs-row>
                        </div>
                    </vs-col>
                </vs-row>
            </vx-card>
            <div style="display: flex; justify-content: flex-end" class="pt-4">
              <vs-button v-if="addFlg" @click="actionCreate" :disabled="!validateForm && submited" icon="person_add" color="success" style="padding: 8px; margin-right: 5px;height: 37px">登録</vs-button>
                <vs-button v-else @click="actionUpdate" :disabled="!validateForm && submited" icon="assignment" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
                <vs-button v-if="title == '顧客情報更新'" @click="activeDelete = true" icon="delete" color="danger" style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
                <vs-button @click="cancelCreateOrUpdate" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
            </div>
        </vs-popup>

        <!-- AgGrid Table -->
        <ag-grid-vue
            id="myGrid"
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table database"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="usersData"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            :domLayout="domLayout"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @selection-changed="onSelectionChanged"
            @sortChanged="onSortChangedEvent"
            :overlayNoRowsTemplate="noRowsTemplate"
            :detailRowAutoHeight="true"
        >
        </ag-grid-vue>

        <div style="position: relative">
            <!-- ITEMS PER PAGE -->
            <div>
                <div class="flex items-center justify-between">
                    <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                </div>
            </div>
            <!-- pagination -->
            <vs-pagination
                    :total="totalPages"
                    v-model="currentPage"
                    :max="5"
                    class="pr-10 pt-10"
            />
        </div>
    </div>

</template>

<script>
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import { AgGridVue } from 'ag-grid-vue'
    import vSelect       from 'vue-select'
    import EventBus      from '../../../EventBus'
    import {mapActions, mapGetters} from 'vuex'

    // Cell Renderer
    import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'
    import {CUSTOMER_TYPE, GENDER_TYPE, getCustomerTypeName, getGenderName} from "../../../enums/customer";

    //customer-custom fields list
    import CustomerFieldsByCompany from "@/views/admin/customers/parts/CustomerFieldsByCompany";

    const ACT_ROLE = 0;
    const ACT_NORMAL = 1;
    export default {
        components: {
            AgGridVue,
            vSelect,
            CustomerFieldsByCompany,
            // Cell Renderer
            CellRendererActions
        },
        data () {
            return {
                activePopup:     false,
                activeDelete:    false,
                activeError:    false,
                datImportError:    null,
                dataLimited:    false,
                messageErrorMin:    '',
                messageErrorMax:    '',
                messageNotHasHeader:    false,
                messageIncorectFormat : false,
                importHasOtherError:    '',
                submited:        false,
                title:           '',
                id:              null,
                ids:             [],
                errorUpdateOrCreate:    null,
                deleteId:        null,
                //To Import CSV File
                activeUpload:    false,
                fileName:        '',
                file:            null,
                fileUploadCheck: false,
                validFile:       false,
                fileImportError:{
                    message:    '',
                    flag:       false,
                },
                // Filter Options
                filterCustomers: {
                    id: null,
                    name: null,
                    email: null,
                    phone_number: null,
                    customer_type: null,
                    company_name: null,
                    industry_name: null,
                    address: null
                },
                customerType: [
                    { key: CUSTOMER_TYPE.INDIVIDUAL.value, value: CUSTOMER_TYPE.INDIVIDUAL.name },
                    { key: CUSTOMER_TYPE.CORPORATE.value, value: CUSTOMER_TYPE.CORPORATE.name },
                    { key: CUSTOMER_TYPE.DEALER.value, value: CUSTOMER_TYPE.DEALER.name },
                    { key: CUSTOMER_TYPE.BRANCH.value, value: CUSTOMER_TYPE.BRANCH.name },
                    { key: CUSTOMER_TYPE.OTHER.value, value: CUSTOMER_TYPE.OTHER.name }
                ],
                customerTypeFilter: [{ key: null, value: '...'}],
                genderType: [
                    { key: GENDER_TYPE.MEN.value, value:  GENDER_TYPE.MEN.name},
                    { key: GENDER_TYPE.WOMEN.value, value: GENDER_TYPE.WOMEN.name},
                    { key: GENDER_TYPE.OTHER.value, value: GENDER_TYPE.OTHER.name}
                ],
                paginationOptions: [
                    10, 100, 500, 1000, 10000
                ],

                //SortServer
                orderBy: 'id',
                orderDir: 'desc',

                //Pagination
                paginationPageSize: 10,
                pageNumber: 1,
                startRow: 0,
                endRow: 0,

                // AgGrid
                noRowsTemplate: "<span>データがありません</span>",
                domLayout: 'autoHeight',
                gridApi: null,
                gridOptions: {
                    onGridSizeChanged: () => {
                        this.gridApi.sizeColumnsToFit();
                    }
                },
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    suppressMenu: true,
                    sortingOrder: ['asc', 'desc'],
                    wrapText: true,
                    autoHeight: true,
                },
                columnDefs: [
                    {
                        headerName: 'ID',
                        field: 'id',
                        width: 150,
                        filter: true,
                        checkboxSelection: true,
                        headerCheckboxSelectionFilteredOnly: true,
                        headerCheckboxSelection: true,
                        sort: 'desc',
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '名前',
                        field: 'name',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'よみがな',
                        field: 'name_kana',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'メールアドレス',
                        field: 'email',
                        filter: true,
                        width: 225,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '電話',
                        field: 'phone_number',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'お客様種別',
                        field: 'customer_type',
                        filter: true,
                        width: 140,
                        unSortIcon: true,
                        comparator: (val1, val2) => val1-val2,
                        suppressMovable: true,
                    },
                    {
                        headerName: '会社名',
                        field: 'company_name',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'よみがな',
                        field: 'company_name_kana',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '性別',
                        field: 'gender_text',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '業種名',
                        field: 'industry_name',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '郵便番号',
                        field: 'postal_code',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '都道府県',
                        field: 'prefecture_name',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '住所',
                        field: 'address',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'FAX',
                        field: 'fax_number',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '備考',
                        field: 'remarks',
                        filter: true,
                        width: 170,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '',
                        field: 'actions',
                        width: 130,
                        cellRendererFramework: 'CellRendererActions',
                        unSortIcon: false,
                        suppressMovable: true,
                    }
                ],

                // Cell Renderer Components
                components: {
                    CellRendererActions
                },
                customer: null,
                subscriptionsForCustomer: [],
                dataExport: [],
                labelExport: {},
                addFlg: false,
                initialCustomer: {
                    id: null,
                    last_name: '',
                    first_name: '',
                    last_name_kana: '',
                    first_name_kana: '',
                    email1: '',
                    email2: '',
                    phone_number1: '',
                    phone_number2: '',
                    customer_type_flg: 0,
                    company_name: '',
                    company_name_kana: '',
                    gender: 0,
                    industry_name: '',
                    department_name: '',
                    postal_name: '',
                    prefecture_name: '',
                    address: '',
                    fax_number: '',
                    mail_domain: '',
                    retailer_name: '',
                    remarks: ''

                },
                prefectureOptions: [
                    { key: 0, value: '北海道' },
                    { key: 1, value: '青森県' },
                    { key: 2, value: '岩手県' },
                    { key: 3, value: '宮城県' },
                    { key: 4, value: '秋田県' },
                    { key: 5, value: '山形県' },
                    { key: 6, value: '福島県' },
                    { key: 7, value: '茨城県' },
                    { key: 8, value: '栃木県' },
                    { key: 9, value: '群馬県' },
                    { key: 10, value: '埼玉県' },
                    { key: 11, value: '千葉県' },
                    { key: 12, value: '東京都' },
                    { key: 13, value: '神奈川県' },
                    { key: 14, value: '新潟県' },
                    { key: 15, value: '富山県' },
                    { key: 16, value: '石川県' },
                    { key: 17, value: '福井県' },
                    { key: 18, value: '山梨県' },
                    { key: 19, value: '長野県' },
                    { key: 20, value: '岐阜県' },
                    { key: 21, value: '静岡県' },
                    { key: 22, value: '愛知県' },
                    { key: 23, value: '三重県' },
                    { key: 24, value: '滋賀県' },
                    { key: 25, value: '京都府' },
                    { key: 26, value: '大阪府' },
                    { key: 27, value: '兵庫県' },
                    { key: 28, value: '奈良県' },
                    { key: 29, value: '和歌山県' },
                    { key: 30, value: '鳥取県' },
                    { key: 31, value: '島根県' },
                    { key: 32, value: '岡山県' },
                    { key: 33, value: '広島県' },
                    { key: 34, value: '山口県' },
                    { key: 35, value: '徳島県' },
                    { key: 36, value: '香川県' },
                    { key: 37, value: '愛媛県' },
                    { key: 38, value: '高知県' },
                    { key: 39, value: '福岡県' },
                    { key: 40, value: '佐賀県' },
                    { key: 41, value: '長崎県' },
                    { key: 42, value: '熊本県' },
                    { key: 43, value: '大分県' },
                    { key: 44, value: '宮崎県' },
                    { key: 45, value: '鹿児島県' },
                    { key: 46, value: '沖縄県' },
                ],

                // Todo customize setting of company
                fieldAdd: {
                  field_name: '',
                  field_type: 1, // 1: Number, 2: dateTime, 3: text
                },
                addFieldPopup: false,
                addFieldAct: false,
                customerFieldsByCompany: [],
                customerFieldsRerender : 0,
                companyAction: 0, // 0: can update or delete, 1: normal
            }
        },
        watch: {
            async paginationPageSize(val){
                await this.setPagination(val);
            },
            activePopup(val){
                if (!val) this.errorUpdateOrCreate = null
            }
        },
        computed: {
            ...mapGetters({
                getSubscriptions: 'subscriptions/getSubscriptions'
            }),
            validateForm(){
                return !this.errors.any()
            },
            addFieldValidate(){
              return this.fieldAdd.field_name.length < 1 && this.addFieldAct;
            },
            usersData () {
                let usersData = []
                this.$store.state.customer.customers.forEach((elem) => {
                    let name = [elem.last_name,elem.first_name].filter(item => item).join(' ');
                    let name_kana = [elem.last_name_kana,elem.first_name_kana].filter(item => item).join(' ');
                    let phone_number = [elem.phone_number1, elem.phone_number2].filter(item => item).join(', ');
                    let email = [elem.email1, elem.email2].filter(item => item).join(', ');
                    const customer_type_object = this.customerType.find(item => item.key === elem.customer_type_flg)
                    let customer_type = ""
                    if (customer_type_object) customer_type = customer_type_object.value
                    let gender_text = elem.gender === 0 ? '男' : (elem.gender === 1 ? '女' : 'その他')
                    usersData.push(Object.assign({name, name_kana, phone_number, email, customer_type, gender_text}, elem));
                });
                return usersData
            },
            totalPages () {
                return parseInt(this.$store.state.customer.infoDB.totalPage)
            },
            totalRow(){
                return parseInt(this.$store.state.customer.infoDB.totalRow)
            },
            currentPage: {
                get () {
                    return this.pageNumber
                },
                async set (val) {
                    this.pageNumber = val
                    await this.fetchCustomerList();
                    this.ids = []
                    this.gridApi.paginationGoToPage(val-1)
                }
            },
            dialogTitle() {
                return this.addFlg ? '顧客情報登録' : '顧客情報更新'
            }
        },
        methods: {
            ...mapActions({
                createCustomer: 'customer/createCustomer',
                updateCustomer: 'customer/updateCustomer',
                getCustomer: 'customer/getCustomer',
                getCustomers: 'customer/getCustomers',
                search: 'customer/search',
                deleteCustomers: 'customer/deleteCustomers',
                deleteCustomer: 'customer/deleteCustomer',
                importCustomer: 'customer/importCustomer',
                createCustomerField: 'customer/createCustomerField',
                getCustomerFields: 'customer/getCustomerFieldsByCompany',
            }),
            convertErrorImport(error) {
                if (error) {
                    return JSON.stringify(error).replace(/["'\[\]]/g, '');
                } else return error
            },
            importFileChange(event){
                let file = event.target.files[0];
                let fileNameExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
                if(file){
                    if(fileNameExtension != "csv"){
                        this.fileUploadCheck = false;
                        this.validFile = false;
                        this.fileImportError.flag = true;
                        this.fileImportError.message = "CSVファイルを選択してください。"
                    }
                    else if(file.size > 1024*1024*100){
                      this.fileUploadCheck = false;
                      this.validFile = false;
                      this.fileImportError.flag = true;
                      this.fileImportError.message = "CSVファイルのサイズが100MBを超えています。"
                    }
                    else{
                        this.fileImportError.flag = false;
                        this.fileImportError.message = "";
                        this.file = file;
                        this.fileUploadCheck = true;
                        this.fileName = file.name;
                        this.validFile = true;
                    }
                }
            },
            resetFileImport(){
                this.$refs.fileUpload.value = ''
                this.activeUpload = false
                this.fileName = ''
                this.file = null
                this.fileUploadCheck = false
                this.validFile = false
                this.fileImportError.message = ''
                this.fileImportError.flag = false
            },
            onSelectionChanged() {
                this.ids = this.gridApi.getSelectedRows().map(user => user.id)
            },
            onSortChangedEvent(event){
                let columns = event.columnApi.getAllColumns();
                let root = this;
                columns.forEach(function(column){
                    if (column.getSort()){
                        root.orderDir = column.getSort()
                        const orderBy  = column.getColId()
                        if (orderBy === 'name') {
                          root.orderBy = 'last_name'
                        }
                        if (orderBy === 'name_kana') {
                          root.orderBy = 'last_name_kana'
                        }
                        if (orderBy === 'phone_number') {
                          root.orderBy = 'phone_number1'
                        }
                        if (orderBy === 'email') {
                          root.orderBy = 'email1'
                        }
                        root.fetchCustomerList();
                        return;
                    }
                });
            },
            fetchCustomerList(){
                //fetchUser with condition
                this.getCustomers({
                    orderBy: this.orderBy,
                    orderDir: this.orderDir,
                    limit: this.paginationPageSize,
                    page: this.pageNumber
                    }).then(response=>{
                      this.subscriptionsForCustomer = response.subscriptions
                })
            },
            searchWithOrder() {
                this.search({
                    id: this.filterCustomers.id,
                    email: this.filterCustomers.email,
                    search_name: this.filterCustomers.name,
                    phone_number: this.filterCustomers.phone_number,
                    customer_type_flg: this.filterCustomers.customer_type,
                    company_name: this.filterCustomers.company_name,
                    industry_name: this.filterCustomers.industry_name,
                    address: this.filterCustomers.address,
                    })
            },
            setUpCreate(){
                this.submited = false;
                this.companyAction = ACT_NORMAL;
                // clear all fields before create
                this.addFlg = true;
                this.customer = Object.assign({}, this.initialCustomer);
                this.activePopup = true
                this.$validator.reset()
                if (this.subscriptionsForCustomer)
                  this.subscriptionsForCustomer = this.subscriptionsForCustomer.map(item => ({...item, isCheck: true}))
            },
            async actionCreate(){
                await this.$validator.validateAll();
                if(!this.validateForm){
                    this.submited = true; // first: no show error => after submited: show error
                }
                else{
                  let subscriptions = this.subscriptionsForCustomer.filter(subscription => subscription.isCheck)
                  subscriptions = subscriptions.map(subscription => {
                    return {
                      customer_id: this.customer.id,
                      subscription_id: subscription.id
                    }
                  })


                    const new_arr = Object.assign({}, this.customer);
                    new_arr['prefecture'] = new_arr.prefecture_name;
                    delete new_arr.prefecture_name;

                    let res = await this.createCustomer({...new_arr, subscriptions: subscriptions,company_customize_fields: this.customerFieldsByCompany});
                    if (typeof res !== 'undefined' &&  res.hasOwnProperty('errors')){
                        this.errorUpdateOrCreate = Object.values(res.errors)[0][0]
                    } else {
                        this.activePopup = false
                        await this.fetchCustomerList()
                    }
                    this.ids = []

                }
            },
            async actionUpdate(){
                const isValidate = await this.$validator.validateAll();
                if(!isValidate){
                  this.submited = true; // first: no show error => after submited: show error
                  return
                }
                let subscriptions = this.subscriptionsForCustomer.filter(subscription => subscription.isCheck)
                subscriptions = subscriptions.map(subscription => {
                    return {
                        customer_id: this.customer.id,
                        subscription_id: subscription.id
                    }
                })

                const new_arr = Object.assign({}, this.customer);
                new_arr['prefecture'] = new_arr.prefecture_name;
                delete new_arr.prefecture_name;

                let res = await this.updateCustomer({...new_arr, subscriptions: subscriptions,company_customize_fields: this.customerFieldsByCompany});
                if (res.errors){
                    this.errorUpdateOrCreate = Object.values(res.errors)[0][0]
                } else {
                    this.cancelCreateOrUpdate();
                    await this.fetchCustomerList()
                    this.errorUpdateOrCreate = null
                }
                this.ids = []

            },
            // confirm delete
            async confirmDelete(){
                await this.deleteSelect();
                this.activeDelete = false
                this.activePopup = false
            },
            // do delete
            async deleteSelect () {
                await this.deleteCustomers(this.ids)
                this.gridApi.deselectAll()
                this.ids = []
                await this.fetchCustomerList()
            },
            // import customer
            async importCSV(){
                this.datImportError = null;
                this.dataLimited = false;
                this.messageErrorMax = '';
                this.messageErrorMin = '';
                this.messageNotHasHeader = '';
                this.messageIncorectFormat = '';
                let data = new FormData();
                data.append('file', this.file);
                const headers = {
                    'Content-Type': 'multipart/form-data',
                }
                let dataImport =  await this.importCustomer(data, headers);
                this.activeUpload = false
                this.resetFileImport();
                await this.fetchCustomerList();
                if (dataImport  && dataImport.status == false) {
                    this.activeError = true
                    this.datImportError = dataImport.dataError
                    if (dataImport.dataLimited){
                        this.dataLimited = dataImport.dataLimited
                        if (dataImport.dataError == 'min') {
                            this.messageErrorMin = 'min'
                        }
                        if (dataImport.dataError == 'max') {
                            this.messageErrorMax = 'max'
                        }
                        if (dataImport.dataError == 'File Import Not Has Header') {
                            this.messageNotHasHeader = true
                        }
                        if(dataImport.dataError == 'The CSV file format is incorrect'){
                            this.messageIncorectFormat = true;
                        }
                    }

                }
                if (dataImport  && dataImport.message && dataImport.success == false) {
                    this.activeError = true
                    this.importHasOtherError = dataImport.message
                }
                if (dataImport && dataImport.file != undefined) {
                    this.activeError = true
                    this.importHasOtherError = 'ファイル形式が正しくありません。'
                    this.datImportError = null;
                    this.dataLimited = false;
                }

            },
            async resetColFilters () {
            // Reset Grid Filter
            this.gridApi.setFilterModel(null)
            this.gridApi.onFilterChanged()
            this.filterCustomers  = {
                id: null,
                name: null,
                email: null,
                phone_number: null,
                customer_type: null,
                company_name: null,
                industry_name: null,
                address: null
            },
                this.ids = []
            await this.fetchCustomerList()
            this.$refs.filterCard.removeRefreshAnimation()
        },
        async setPagination(val){
            this.gridApi.paginationSetPageSize(val);
            this.pageNumber = 1
            await this.fetchCustomerList(); //let change
            this.ids = []
        },
        async editListener(id) {
            this.submited = false;
            this.companyAction = ACT_NORMAL;
            this.getCustomer(id)
                .then(data => {
                    this.customer = {...data.customer}
                    this.subscriptionsForCustomer = []
                    this.subscriptionsForCustomer = data.subscriptions.map(subscription => {
                        return Object.assign(subscription, { isCheck: Boolean(subscription.customer_id)})
                    })
                    this.customerFieldsByCompany = data.company_customize_fields;
                })
                .catch(error => {
                    this.customers = Object.assign({}, this.initialCustomer)
                })
            this.addFlg = false;
            this.activePopup = true;
            await this.$validator.reset()
        },
        onExportCSV(){
            const subscriptions = this.getSubscriptions()

            const labelSubscriptions = {}
            subscriptions.map(subscription => {
                labelSubscriptions[`subscription_${subscription.id}`] = { title: subscription.name }
            })

            const labelCustomerExport = Object.assign({
                id: { title: 'ID' },
                customerType: { title: 'お客様種別' },
                lastName: { title: '名前(姓)' },
                firstName: { title: '名前(名)' },
                lastNameKana: { title: '名前よみがな(姓)' },
                firstNameKana: { title: '名前よみがな(名)' },
                gender: { title: '性別' },
                email1: { title: 'メールアドレス1' },
                email2: { title: 'メールアドレス2' },
                phoneNumber1: { title: '電話番号1' },
                phoneNumber2: { title: '電話番号2' },
                faxNumber: { title: 'FAX' },
                companyName: { title: '会社名' },
                companyNameKana: { title: '会社名よみがな' },
                industryName: { title: '業種名' },
                departmentName: { title: '部署名' },
                postalCode: { title: '郵便番号' },
                prefectureName: { title: '都道府県' },
                address: { title: '住所' },
                retailerName: { title: '購入先' },
                remarks: { title: '備考' },
            }, labelSubscriptions)

            const dataExport = this.usersData.map(customer => {
                const subscriptionsOfCustomer = customer.subscription ? customer.subscription.split(',') : []
                const customerInfo = {
                    id: customer.id || '',
                    customerType: getCustomerTypeName(customer.customer_type_flg),
                    lastName: customer.last_name || '',
                    firstName: customer.first_name || '',
                    lastNameKana: customer.last_name_kana || '',
                    firstNameKana: customer.first_name_kana || '',
                    gender: getGenderName(customer.gender),
                    email1: customer.email1 || '',
                    email2: customer.email2 || '',
                    phoneNumber1: customer.phone_number1 || '',
                    phoneNumber2: customer.phone_number2 || '',
                    faxNumber: customer.fax_number || '',
                    companyName: customer.company_name || '',
                    companyNameKana: customer.company_name_kana || '',
                    industryName: customer.industry_name || '',
                    departmentName: customer.department_name || '',
                    postalCode: customer.postal_name || '',
                    prefectureName: customer.prefecture_name || '',
                    address: customer.address || '',
                    retailerName: customer.retailer_name || '',
                    remarks: customer.remarks || '',
                }

                subscriptions.map(subscription => {
                    customerInfo[`subscription_${subscription.id}`] =
                        subscriptionsOfCustomer.find(subscriptionOfCustomer => subscriptionOfCustomer == subscription.id)
                            ? true : false
                })

                return customerInfo
            })

            this.$refs.exportCSV.labels = labelCustomerExport
            this.$refs.exportCSV.jsonData = dataExport
            this.$refs.exportCSV.handleClick()
            // console.log(this.$refs.exportCSV)
        },
        deleteListener(id) {
            this.deleteId = id
            this.activeDelete = true
        },
        cancelCreateOrUpdate() {
            this.activePopup = false;
            this.customers = Object.assign({}, this.initialCustomer)
            this.customerFieldsByCompany.forEach(field => field.value = null);
        },
        async fetchCustomerFields(){
            await this.getCustomerFields()
                .then(res => {
                    this.customerFieldsByCompany = res
                    this.customerFieldsRerender++;
                });
        },
        async addField(){
            this.addFieldAct = true;
            if(!this.addFieldValidate){
                await this.createCustomerField(this.fieldAdd);
                this.fieldAdd.field_name = '';
                this.fieldAdd.field_type = 1;
                this.addFieldAct = false;
                await this.fetchCustomerFields();
            }
        },
        openFieldSetting(){
            this.companyAction = ACT_ROLE;
            this.addFieldPopup = true;
        },
        cancelAddField() {
            this.addFieldPopup = false;
            this.fieldAdd.field_name = '';
            this.fieldAdd.field_type = 1;
            this.addFieldAct = false;
        },
    },
    mounted () {
        this.gridApi = this.gridOptions.api
        this.customerTypeFilter.push(...this.customerType);
        if (this.$vs.rtl) {
            const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
            header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
        }
        EventBus.$on('editRecord', this.editListener)
        EventBus.$on('deleteRecord', this.deleteListener);
        // save paginationSize to sessionStorage (when fresh browser)
        const root = this
        window.addEventListener('beforeunload', function(){
            sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
        })
    },
    async created () {
        this.customer = Object.assign({}, this.initialCustomer)
        await this.fetchCustomerList();
        await this.fetchCustomerFields();
    },
    beforeMount(){
        // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
        let paginationPageSize = sessionStorage.getItem("paginationPageSize");
        if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
    },
    updated(){
        // set paginationPageSize = 10 (default) when change page/route
        sessionStorage.setItem("paginationPageSize", 10)
        // calc number startRow and endRow
        this.$nextTick(()=>{
            if(!this.$store.state.loading && this.usersData.length > 0){
                this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
                if(this.usersData.length == this.paginationPageSize) this.endRow = this.pageNumber*this.paginationPageSize
                else this.endRow = this.paginationPageSize*this.pageNumber + this.usersData.length - this.paginationPageSize
            }
            if(this.usersData.length == 0){
                this.endRow = 0
                this.startRow = 0
            }
        });
    },
    beforeDestroy(){
        EventBus.$off('editRecord', this.editListener);
        EventBus.$off('deleteRecord', this.deleteListener);
    },
    destroyed(){
        // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
        document.getElementById('dialogDelete').style.display = 'none'
        document.getElementById('dialogUpdate').style.display = 'none'
    }

}

</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/view/customer.scss";
:root {
  /* Dropdown */
  --vs-dropdown-max-height: 205px !important;
}
#dialogUpdate .show-error {
  color: red;
  position: absolute;
  top: -20px;
}
.error-statistical{
  width: 100%;
  min-height: 150px;
  background: #FFE4E1;
  padding: 15px;

  h4 {
    font-size: 15.5px;
    line-height: 30px;
    color: #CD5C5C;
  }
  #dialogImportError .vuesax-app-is-ltr .vs-popup--content {
    margin-left: 2px !important;
  }
}
 #dialogImportError .vs-popup--content {
  padding-left: 18px !important;
}

</style>
